<template>
  <v-container>
    <v-card elevation="2">
      <DetallesApelacion
        v-if="apelacion"
        :apelacion="apelacion"
        :role="roleUser"
        @closeModal="$router.push({ name:'Tocas', params: {
            title: active_tab.title,
            value: active_tab.value,
            icon: active_tab.icon
          }
        })"
      >
      </DetallesApelacion>
      <v-toolbar id="focusOnElement" dense dark color="indigo lighten-1">
        <v-toolbar-title class="text-uppercase">Excusar Magistrado</v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card  class="py-0 mb-0 pt-0"  elevation="2">
        <v-col cols="12" class="py-2 mb-0 pt-0">
          <div class="mx-4 py-3" style="background-color: #FFFFFF">
            <!-- <v-card class="mx-0" v-if="roleUser == 'Magistrado'"> -->
            <v-card class="mx-0">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-toolbar
                  color="#E0E0E0"
                  dense
                  flat
                >
                  <h3 class="font-weight-bold" style="color: #0D47A1">Motivos de la Excusa</h3>
                </v-toolbar>
                <v-container class="mt-9" v-if="roleUser == 'magistrado'">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      class="mt-n6"
                    >
                    <v-textarea
                      v-model="motivos"
                      outlined
                      name="input-7-4"
                      required
                      :rules="[rules.required]"
                    ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-btn
                    block
                    color="teal"
                    :loading="loading"
                    :disabled="!valid"
                    @click="validate"
                    class="mb-6"
                  >
                    <span style="color:white;">GUARDAR
                    <v-icon>mdi-content-save</v-icon></span>
                  </v-btn>
                  <v-divider></v-divider>
                </v-container>
                </v-form>
              </v-card>
              <br>
          </div>
        </v-col>
      </v-card>

    </v-card>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import { VueEditor } from 'vue2-editor';
  import DetallesApelacion from "../../components/DetallesApelacion";

  export default {
    components: {
       DetallesApelacion
    },
    props: {
      source: String
    },
    data(){
      return{
        motivos:'',
        valid: false,
        loading: false,
        apelacion: null,
        cuenta: {},
        active_tab: {},
        rules: {
          required:v => !!v || 'Campo requerido',
          requiredSelect:v => !!v|| 'Campo requerido'
        }
      }
    },
    computed: {
      formTitle () {
        return 'Add Observación'
      },
      ...mapGetters(["currentUser", "roleUser"]),
    },
    mounted() {
      this.cuenta =  JSON.parse(localStorage.getItem("currentCuenta"))
      this.apelacion = this.cuenta.apelacion
      this.active_tab = this.$route.params
      setTimeout(function () {
        var element = document.getElementById("focusOnElement");
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        });
      }.bind(this), 200);
    },
    methods:{
      getApelacion(){
        this.$store.dispatch("SHOW_APELACION", {
          url: '/apelacion/'+ this.cuenta.apelacion_id
        }).then(response => {
          this.apelacion = response.data.data.apelacion
        });
      },
      getCuenta(){
        this.$store.dispatch("SHOW_CUENTA", {
          url: '/cuenta/'+this.cuenta.id
        }).then(response => {
          this.cuenta = response.data.data.cuenta
        });
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.save();
        }
      },
      save() {
        var data = {
          cuenta_id:this.cuenta.id,
          motivos: this.motivos,
        }
        this.$store.dispatch("CREATE_OBSERVACION", { url: '/cuenta/excusar-toca', data: data }).then(response => {
            this.loading = false;
            if (response.data.status == "ok") {
              this.$swal({
                title: "Éxito!!!",
                text: "Excusa agregada correctamente.",
                icon: "success",
                confirmButtonText: "Aceptar"
              });
            }
            this.$router.push({ name:'Bandeja', params: {
                title: this.active_tab.title,
                value: Number(this.active_tab.value),
                icon: this.active_tab.icon
              }
            })
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: "No se pudo guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
            this.$router.push('/tocas')
          });
      },
    }
  }
</script>